import { axiosCore } from './http-core-service';
import { PageAdminDto } from './dtos/page-admin.dto';

/**
 * Récupération des pages.
 * @param key identifiant de la page
 */
export const getPageAdmin = async (key: string): Promise<PageAdminDto> => {
    const response = await axiosCore.get(`/api/admin/pages/${key}`);
    return response.data;
};

/**
 * Mise à jour d'une page.
 * @param page informations d'une page
 */
export const updatePageAdmin = async (page: PageAdminDto): Promise<void> => {
    const response = await axiosCore.put(`/api/admin/pages/${page.key}`, page);
    return response.data;
};
